'use client';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import {
  forgotPasswordStore,
  selectForgotPasswordObject,
  selectForgotPasswordStatus,
  selectValidationErrors,
  useForgotPasswordStore,
} from '@/stores/forgotPasswordStore';
import { SubmitStatuses } from '@/util/storeUtilities';
import { Label } from '@radix-ui/react-label';
import { LoaderCircle } from 'lucide-react';
import { toast } from 'react-toastify';
import { equalityFn } from 'wired-store';

export function InitiateForgotPasswordComponent() {
  const { forgotPasswordSubmitStatus, validationErrors, forgotPasswordObj } = useForgotPasswordStore(
    (state) => ({
      forgotPasswordSubmitStatus: selectForgotPasswordStatus(state),
      validationErrors: selectValidationErrors(state),
      forgotPasswordObj: selectForgotPasswordObject(state),
    }),
    equalityFn,
  );

  async function submitForgotPassword() {
    await forgotPasswordStore.initiateForgotPassword();
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="container mx-auto px-4">
        <div>
          <Card>
            <CardHeader>
              <CardTitle>Reset Password</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <div className="space-y-4">
                  <div>
                    <Label htmlFor="new-password">Email Address</Label>
                    <Input
                      id="new-password"
                      className="text-gray-900"
                      value={forgotPasswordObj.email}
                      onChange={(e) => {
                        forgotPasswordStore.updateEmail(e.target.value);
                      }}
                    />
                    {validationErrors.email ? <p className="text-red-500">{validationErrors.email}</p> : null}
                  </div>
                </div>
              </div>

              <Button
                type="submit"
                style={{ width: '200px' }}
                className="bg-[#00B67A] hover:bg-[#00A067]"
                disabled={
                  Object.keys(validationErrors).length > 0 || forgotPasswordSubmitStatus === SubmitStatuses.SUBMITTING
                }
                onClick={async () => {
                  await submitForgotPassword();
                  const { submitStatus, notifySuccess, notifyFailure } = forgotPasswordStore.getState();
                  if (submitStatus === SubmitStatuses.SUBMITTED) {
                    toast.success(notifySuccess);
                  }
                  if (submitStatus === SubmitStatuses.FAILED) {
                    toast.error(notifyFailure);
                  }
                }}
              >
                {forgotPasswordSubmitStatus === SubmitStatuses.SUBMITTING ? (
                  <LoaderCircle className="icon-spin" style={{ width: '30px', height: '30px' }} strokeWidth={2} />
                ) : (
                  <span className="inline-flex items-center">Submit</span>
                )}
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
